module.exports = __webpack_public_path__ + "img/exercise_image.4b5a2cfe.svg";